import React, { useEffect, useState } from "react";
import TongueTwisterForm from "./TongueTwisterForm";
import "./tongueTwister.css";
import { fetchAllTwisters, deleteTwister } from "./adminTongueTwisterService";

const AdminTongueTwisterPage = () => {
  const [twisters, setTwisters] = useState([]);
  const [editing, setEditing] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  useEffect(() => {
    loadTwisters();
  }, [page]);

  const loadTwisters = async () => {
    setLoading(true);
    const res = await fetchAllTwisters({ page, size: 20 });
    if (res.status === 200 && res.data) {
      setTwisters(res.data.content || res.data.data || []);
      setTotalPages(res.data.totalPages || 0);
    } else {
      setTwisters([]);
      alert(res.message || "Failed to load data");
    }
    setLoading(false);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this tongue twister?")) return;
    const res = await deleteTwister(id);
    if (res.status === 200 || res.status === 204) {
      loadTwisters();
    } else {
      alert(res.message);
    }
  };

  const onSaved = () => {
    setShowForm(false);
    setEditing(null);
    loadTwisters();
  };

  return (
    <div className="admin-container">
      <div className="admin-header">
        <h2>Tongue Twister Management</h2>
        <button
          onClick={() => {
            setEditing(null);
            setShowForm(true);
          }}
        >
          + New Twister
        </button>
      </div>

      {showForm && (
        <TongueTwisterForm
          data={editing}
          onSaved={onSaved}
          onCancel={() => setShowForm(false)}
        />
      )}

      {loading ? (
        <p>Loading...</p>
      ) : (
        <table className="announcement-table">
          <thead>
            <tr>
              <th>Title</th>
              <th>Difficulty</th>
              <th>YouTube</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {twisters.length === 0 ? (
              <tr>
                <td colSpan="4">No data found</td>
              </tr>
            ) : (
              twisters.map((t) => (
                <tr key={t.id}>
                  <td>{t.title}</td>
                  <td>
                    <span className="status-badge">{t.difficulty}</span>
                  </td>
                  <td>
                    {t.youtubeLink ? (
                      <a href={t.youtubeLink} target="_blank" rel="noreferrer">
                        Link
                      </a>
                    ) : (
                      "—"
                    )}
                  </td>
                  <td>
                    <button
                      onClick={() => {
                        setEditing(t);
                        setShowForm(true);
                      }}
                    >
                      Edit
                    </button>
                    <button
                      className="delete-btn"
                      onClick={() => handleDelete(t.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      )}

      {totalPages > 1 && (
        <div style={{ marginTop: 20 }}>
          <button disabled={page === 0} onClick={() => setPage(page - 1)}>
            Prev
          </button>
          <span style={{ margin: "0 10px" }}>
            Page {page + 1} / {totalPages}
          </span>
          <button
            disabled={page + 1 >= totalPages}
            onClick={() => setPage(page + 1)}
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default AdminTongueTwisterPage;
